import { Component, Input } from '@angular/core';
import { UserQualificationCallViewModel } from 'models/generated/Models.UserQualificationCallView';
import { CurrencyPipe } from 'pipes/currency.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserImageDirective } from 'directives/user-image.directive';

@Component({
	selector: 'blocklist-user',
	templateUrl: './blocklist-user.component.html',
	styleUrls: ['./blocklist-user.component.scss'],
	imports: [CurrencyPipe, TranslatePipe, UserImageDirective]
})
export class BlockListUserComponent {

	@Input() user!: UserQualificationCallViewModel;

	constructor() {
	}
}
